<template>
  <div class="hospitalCassetteSimple">
    <div
      class="hospitalCassetteSimple_item"
      v-for="item in items"
      :key="item.id"
    >
      <div v-if="isSeminar">
        <p class="hospitalCassetteSimple_hospital">
          {{ item.hospital_name }}
        </p>
        <p class="hospitalCassetteSimple_name">{{ item.program }}</p>
      </div>
      <p v-else class="hospitalCassetteSimple_name">{{ item.hospital_name }}</p>
      <dl class="hospitalCassetteSimple_data">
        <dt v-if="item.prefectures">所在地</dt>
        <dd v-if="item.prefectures">
          {{ item.prefectures }}{{ item.hospital_address }}
        </dd>
        <dt v-if="item.regist_dt">申込日</dt>
        <dd v-if="item.regist_dt">
          {{ dateFormat(item.regist_dt, false, false) }}
        </dd>
      </dl>
      <ul class="hospitalCassetteSimple_tags">
        <li
          :data-check="dataCheck(item.hospital_id, 'favorite')"
          data-icon="heart"
        >
          お気に入り登録
        </li>
        <li
          :data-check="dataCheck(item.hospital_id, 'inspection')"
          data-icon="hospital"
        >
          病院見学申込み
        </li>
        <li
          :data-check="dataCheck(item.hospital_id, 'request')"
          data-icon="document"
        >
          資料請求申込み
        </li>
      </ul>
      <div class="hospitalCassetteSimple_button">
        <Button
          label="申込み内容の確認"
          :handleClick="
            () => {
              $router.push(
                !isSeminar
                  ? `/mypage/${page}/detail/${item.id}`
                  : `/mypage/${page}/detail/${item.id}_${item.s_training_id}`
              )
            }
          "
          primary
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import { dateFormat } from '@/utils/commonMethods'

export default {
  name: 'HospitalCassetteSimple',

  components: {
    Button
  },

  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    page: String,
    isSeminar: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any) {
    const store = useStore()

    const dataCheck = (id: number, data: string) => {
      const dataString = !props.isSeminar ? data : `s_${data}`
      const historyIds = store.state.userInfo[dataString + '_history'].map(
        (el: any) => {
          return el.hospital_id
        }
      )
      const isActive = historyIds.indexOf(id) !== -1

      return isActive ? 'on' : 'off'
    }

    return {
      dataCheck,
      dateFormat
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalCassetteSimple {
  @include mixins.media() {
    display: flex;
    flex-wrap: wrap;
    margin: -14px -27px;
  }
}

.hospitalCassetteSimple_item {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  padding: 18px;
  border-radius: 5px;
  background: #fff;
  border: 1px solid rgb(228, 228, 228);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
  color: #666;
  font-size: 1.3rem;
  @include mixins.media() {
    flex-basis: calc(50% - 54px);
    margin: 14px 27px;
  }
}

.hospitalCassetteSimple_name {
  flex-basis: 100%;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 10px;
}

.hospitalCassetteSimple_hospital {
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.5;
}

.hospitalCassetteSimple_data {
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(100% - 110px);
  font-size: 1.3rem;
  line-height: 1.46;
  padding-right: 16px;

  > dt {
    font-weight: 500;

    &::after {
      content: '：';
    }
  }

  > dt + dd,
  > dd + dt {
    margin-top: 5px;
  }
}

.hospitalCassetteSimple_tags {
  flex: 0 0 110px;

  > li {
    box-sizing: border-box;
    border: 1px solid var.$color-border-gray;
    border-radius: 3px;
    color: var.$color-gray;
    text-align: center;
    font-size: 1rem;
    line-height: 22px;

    &[data-icon]::before {
      margin-right: 3px;
      vertical-align: -1px;
    }

    &[data-icon='heart']::before {
      display: inline-block;
      content: '';
      background: url('~@/assets/images/icon/heart-gray.svg') no-repeat;
      background-size: 100% 100%;
      width: 11px;
      height: 10px;
    }

    &[data-icon='hospital']::before {
      display: inline-block;
      content: '';
      background: url('~@/assets/images/icon/hospital-02-gray.svg') no-repeat;
      background-size: 100% 100%;
      width: 11px;
      height: 10px;
    }

    &[data-icon='document']::before {
      display: inline-block;
      content: '';
      background: url('~@/assets/images/icon/document-gray.svg') no-repeat;
      background-size: 100% 100%;
      width: 8px;
      height: 10px;
    }

    &[data-check='on'] {
      border-color: var.$color-main;
      color: var.$color-main-text;

      &[data-icon='heart']::before {
        background-image: url('~@/assets/images/icon/heart.svg');
      }

      &[data-icon='hospital']::before {
        background-image: url('~@/assets/images/icon/hospital-02.svg');
      }

      &[data-icon='document']::before {
        background-image: url('~@/assets/images/icon/document.svg');
      }
    }
  }

  > li + li {
    margin-top: 5px;
  }
}

.hospitalCassetteSimple_button {
  flex-basis: 100%;
  margin-top: 20px;
}
</style>
